// import dotProp from 'dot-prop-immutable'
// import update from 'immutability-helper'
import {
  LOAD_CATEGORY_SUCCESS,
} from '../actions/types'

const initialNewCourseState = {
  videoCourse: [],
}

const addNewCourse = (state = initialNewCourseState, action) => {
  switch (action.type) {
    case LOAD_CATEGORY_SUCCESS:
      return {
        ...state,
        ...action.payload,
      }
    default:
      return state
  }
}

export default addNewCourse



// WEBPACK FOOTER //
// ./src/reducers/addNewCourse.js